import ApplicationController from '../application_controller'

const TEAM_APPROVEMENT_TYPE = 'linemanagers_and_team'

class PositionApprovementSettingsFormController extends ApplicationController {
  static targets = ["type", "teams"]

  connect() {
    const onPositionsApprovementTypeChanged = (newType) => {
      if (newType === TEAM_APPROVEMENT_TYPE) {
        $(this.teamsTarget).fadeIn()
      } else {
        $(this.teamsTarget).fadeOut()
      }
    }

    try {
      const selectedType = $(this.typeTarget).find('input:checked')[0].value

      onPositionsApprovementTypeChanged(selectedType)
    } catch {
      $(this.teamsTarget).fadeOut()
    }

    $(this.typeTarget).on('change', (e) => onPositionsApprovementTypeChanged(e.target.value))
  }
}

export default PositionApprovementSettingsFormController
